var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCcMaster(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M0 5v14c0 .5.5 1 1 1h22c.5 0 1-.5 1-1V5c0-.5-.5-1-1-1H1c-.5 0-1 .5-1 1zm12 10.044A3.894 3.894 0 019.443 16C7.265 16 5.5 14.21 5.5 12s1.765-4 3.943-4c.976 0 1.869.36 2.557.955A3.894 3.894 0 0114.557 8c2.178 0 3.943 1.79 3.943 4s-1.765 4-3.943 4c-.976 0-1.869-.36-2.557-.956z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "M12 8.956A4.015 4.015 0 0010.615 12c0 1.22.537 2.31 1.385 3.045A4.015 4.015 0 0013.385 12c0-1.219-.537-2.31-1.385-3.044z",
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "M12 15.044A3.894 3.894 0 019.443 16C7.265 16 5.5 14.21 5.5 12s1.765-4 3.943-4c.976 0 1.869.36 2.557.956A4.015 4.015 0 0010.615 12c0 1.22.537 2.31 1.385 3.044z",
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "M12 15.044a3.894 3.894 0 002.557.956c2.178 0 3.943-1.79 3.943-4s-1.765-4-3.943-4c-.976 0-1.869.36-2.557.956A4.015 4.015 0 0113.385 12c0 1.219-.537 2.31-1.385 3.044z",
    opacity: 0.22
  }));
}
export default SvgIconCcMaster;